import React from 'react'
import { Helmet } from 'react-helmet'

const defaultMeta = {
    pageTitle: '',
    url: window.location.href || 'https://www.giftcardgranny.com/',
    pageDescription: '',
}

export default function ({ pageTitle, pageDescription }) {
    const title = pageTitle || defaultMeta.pageTitle
    const description = pageDescription || defaultMeta.pageDescription

    return (
        <Helmet>
            <title>{title} | GiftCardGranny</title>
            <meta property="og:title" content={`${title} | GiftCardGranny`} />
            <meta name="twitter:title" content={`${title} | GiftCardGranny`} />

            <meta name="description" content={description} />
            <meta property="og:description" content={description} />
            <meta name="twitter:description" content={description} />

            <meta property="og:url" content={defaultMeta.url} />
            <link rel="canonical" href={defaultMeta.url} />
        </Helmet>
    )
}
